<template>
    <div class="ui card" :class="[selected_pack == pack? 'raised' : '']">
        <div class="content">
            <a class="ui ribbon label" v-if="is_processing" :class="[selected_pack == pack ? 'teal' : 'grey' ]">
                {{ pack.core_waybill_number }}
            </a>
            <a class="ui ribbon label" v-else :class="[selected_pack == pack ? 'teal' : 'grey' ]" @click="select">
                {{ pack.core_waybill_number }}
            </a>
            <SubPack
            v-for="sub_pack in sub_packs"
            :key="sub_pack.identity"
            :pack="sub_pack"
            :selected_pack="selected_pack"
            :all_packs="all_packs"
            :is_processing="is_processing"
            />
        </div>
        <div class="ui bottom attached buttons">
            <div class="ui basic negative disabled button" v-if="is_processing && selected_pack == pack"><i class="remove icon"></i>移除</div>
            <div class="ui basic negative button" v-if="!is_processing && selected_pack == pack" @click="remove"><i class="remove icon"></i>移除</div>
            <div class="ui basic primary disabled button" v-if="is_processing && is_in_pack"><i class="external icon"></i>取出</div>
            <div class="ui basic primary button" v-if="!is_processing && is_in_pack" @click="escape"><i class="external icon"></i>取出</div>
            <div class="ui basic primary disabled button" v-if="is_processing && selected_pack"><i class="archive icon"></i>填包</div>
            <div class="ui basic primary button" v-if="!is_processing && selected_pack" @click="pack_in_selected"><i class="archive icon"></i>填包</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pack: Object,
        selected_pack: Object,
        all_packs: Array,
        is_processing: Boolean,
    },
    data: function() {
        return {
        }
    },
    computed: {
        sub_packs: function() {
            return _.filter(this.all_packs, {"packed_by_number": this.pack.core_waybill_number});
        },
        is_in_pack: function() {
            if (this.pack.packed_by_number) {
                return true;
            } else {
                return false;
            }
        },
    },
    watch: {
    },
    beforeCreate: function () {
        this.$options.components.SubPack = require('./pack.vue');
    },
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        select: function() {
            var that = this;
            var number = that.pack.core_waybill_number;
            that.$bus.$emit("packer_command_center", "selection", number);
        },
        remove: function() {
            var that = this;
            var number = that.pack.core_waybill_number;
            that.$bus.$emit("packer_command_center", "remove_pack", number);
        },
        escape: function() {
            var that = this;
            var number = that.pack.core_waybill_number;
            that.$bus.$emit("packer_command_center", "escape_pack", number);
        },
        pack_in_selected: function() {
            var that = this;
            var number = that.pack.core_waybill_number;
            that.$bus.$emit("packer_command_center", "packing", number);
        },
    },
    components: {
    }
}
</script>
